import {TextField} from '@hconnect/common/components'
import {Stack} from '@mui/material'
import {Control, FieldValues, Path} from 'react-hook-form'

interface TextFieldGroupWithRetakeProps<T extends FieldValues> {
  fields: Array<{
    name: Path<T>
    label: string
    retakeName: Path<T>
  }>
  commentField: {
    name: Path<T>
    label: string
  }
  control: Control<T>
  readOnly?: boolean
}

export const TextFieldGroupWithRetake = <T extends FieldValues>({
  fields,
  commentField,
  control,
  readOnly
}: TextFieldGroupWithRetakeProps<T>) => {
  return (
    <Stack spacing={1}>
      <Stack direction="row" spacing={1}>
        {fields.map((field) => (
          <TextField
            key={field.name}
            fullWidth
            name={field.name}
            label={field.label}
            optional
            control={control}
            readOnly={readOnly}
          />
        ))}
      </Stack>
      <Stack direction="row" spacing={1}>
        {fields.map((field) => (
          <TextField
            key={field.retakeName}
            fullWidth
            name={field.retakeName}
            label={field.label}
            optional
            control={control}
            readOnly={readOnly}
          />
        ))}
      </Stack>
      <TextField
        name={commentField.name}
        label={commentField.label}
        optional
        control={control}
        readOnly={readOnly}
      />
    </Stack>
  )
}
